var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickActionPinIconMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7909",
    x: 0,
    y: 0,
    width: 45,
    height: 45,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29883",
    "data-name": "Group 29883",
    transform: "translate(9.198 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27920",
    "data-name": "Group 27920"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.2, -6)",
    filter: "url(#Rectangle_7909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7909-2",
    "data-name": "Rectangle 7909",
    width: 27,
    height: 27,
    rx: 3,
    transform: "translate(9 6)",
    fill: "#EB1700"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29884",
    "data-name": "Group 29884",
    transform: "translate(4.43 9.765) rotate(-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16680",
    "data-name": "Path 16680",
    d: "M11.584,8.109A2.324,2.324,0,0,1,9.267,5.792V1.158h.579a.574.574,0,0,0,.579-.579A.574.574,0,0,0,9.846,0H1.738a.574.574,0,0,0-.579.579.574.574,0,0,0,.579.579h.579V5.792A2.324,2.324,0,0,1,0,8.109V9.267H5.213v6.371l.579.579.579-.579V9.267h5.213ZM7.982.885c.556-.614-4.593.771-4.593-.121l-.095.865,4.525-.471.163,4.778A3.2,3.2,0,0,0,9,8.109Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickActionPinIconMobile);
export default __webpack_public_path__ + "static/media/quick-action-pin-icon-mobile.687f999533c8bdf8163cc50f0f3f816b.svg";
export { ForwardRef as ReactComponent };